<template>
  <div>
    {{result}}
    <!-- <v-btn flat icon :color="`${overTime ? 'error': 'success'}`" class="ma-0" :class="{'animate-shake': overTime}">
                                <v-icon >timer</v-icon>
                              </v-btn> -->
  </div>
</template>

<script>
import { format, addHours, addMinutes, addSeconds } from "date-fns";
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    overTimeLimit: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      now: 0,
      timer: null,
    };
  },
  methods: {
    timerLoop() {
      let dt = new Date();
      //TODO: change logic using timezone
      let minutes = 0; //dt.getTimezoneOffset();
      dt = new Date(dt.getTime() + minutes * 60000);
      // console.log(dt);
      this.now = Math.trunc(dt / 1000);
      // console.log(this.now);
      // 1min interval
      this.timer = setTimeout(this.timerLoop, 1000);
    },
    format(data, sep = "") {
      return ("0" + data.toString()).slice(-2) + sep;
    },
  },
  mounted() {
    this.timerLoop();
  },
  computed: {
    seconds() {
      return (this.now - this.modifiedDate) % 60;
    },
    minutes() {
      return Math.trunc(((this.now - this.modifiedDate) / 60) % 60);
    },
    hours() {
      return Math.trunc(((this.now - this.modifiedDate) / 60 / 60) % 24);
    },
    days() {
      return Math.trunc((this.now - this.modifiedDate) / 60 / 60 / 24);
    },
    modifiedDate: function() {
      let date = format(this.date);
      let t = this.time.split(":");
      date = addHours(date, t[0]);
      date = addMinutes(date, t[1]);
      date = addSeconds(date, t[2]);
      if (date == "Invalid Date") {
        return 0;
      }
      return Math.trunc(date) / 1000;
    },
    overTime() {
      return this.hours > 0 || this.minutes > this.overTimeLimit;
    },
    result() {
      let time = "";
      // if (this.days) {
      //   time += this.format(this.days) + ":";
      // }
      time +=
        this.format(this.hours, ":") +
        this.format(this.minutes, ":") +
        this.format(this.seconds);
      return time;
    },
    resultInMilliseconds() {
      return (
        this.hours * 60 * 60 * 1000 +
        this.minutes * 60 * 1000 +
        this.seconds * 1000
      );
    },
  },
  watch: {
    resultInMilliseconds(v) {
      this.$emit("milli-seconds", v);
    },
  },
  destroyed() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
};
</script>
